import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from "../../../np-rest/rest";
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'permissions',
    pluginName: 'ADMIN',
    entityName: 'PERMISSION',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''

});


// Fetch Permission action creators
export const fetchPermissionInit = () => {
    return crudActions.fetchInit();
};
export const fetchPermissionStart = () => {
    return crudActions.fetchStart();
};
export const fetchPermissionSuccess = (fetchPermissionCount, listPermissionCount) => {
    return crudActions.fetchSuccess(fetchPermissionCount, listPermissionCount);
};
export const fetchPermissionFail = () => {
    return crudActions.fetchFail();
};


export const fetchPermissionsCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPermissionStart());
        try {
            let countRes = await rest.post("permissions/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchPermissionSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchPermissionFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch permissions."}`,
                options: {
                    variant: 'warning'
                }
            })
            return 0
        }
        catch (error) {
            dispatch(fetchPermissionFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch permissions."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0
        }
    }
}

export const fetchPermissions = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchPermissionStart());
        try {
            let listRes = await rest.post("permissions/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchPermissionSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchPermissionFail());
            return []
        } catch (error) {
            dispatch(fetchPermissionFail());
            return []
        }
    }
}

// Create Permissions  action creators

// Create permissions action creators
export const createPermissionsInit = () => {
    return crudActions.createInit();
};
export const createPermissionsStart = () => {
    return crudActions.createStart();
};
export const createPermissionsSuccess = createdPermissions => {
    return crudActions.createSuccess(createdPermissions);
};
export const createPermissionsFail = error => {
    return crudActions.createFail(error);
};

export const createPermissions = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createPermissionsStart());
        try {
            let res = await rest.post('/permissions/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createPermissionsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created permissions.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createPermissionsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create permissions."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create permissions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createPermissionsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit permissions action creators
export const editPermissionsInit = () => {
    return crudActions.editInit();
};
export const editPermissionsStart = () => {
    return crudActions.editStart();
};
export const editPermissionsSuccess = editedPermissions => {
    return crudActions.editSuccess(editedPermissions);
};
export const editPermissionsFail = error => {
    return crudActions.editFail(error);
};

export const editPermissions = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editPermissionsStart());
        try {
            let res = await rest.post('/permissions/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editPermissionsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated permissions.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editPermissionsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit permissions."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create permissions."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editPermissionsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Permissions  action creators

export const bulkDeletePermissionsInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeletePermissionsStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeletePermissionsSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeletePermissionsFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeletePermissions = permissionIDs => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, permissionIDs);
    };
};

// Delete Permissions  action creators
export const deletePermissionsInit = () => { return crudActions.deleteInit(); };
export const deletePermissionsStart = () => { return crudActions.deleteStart(); };
export const deletePermissionsSuccess = deletedPermissions => { return crudActions.deleteSuccess(deletedPermissions); };
export const deletePermissionsFail = error => { return crudActions.deleteFail(error); };
export const deletePermissions = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// Load permission action creators
export const loadPermissionsInit = () => { return crudActions.loadInit(); };
export const loadPermissionsStart = () => { return crudActions.loadStart(); };
export const loadPermissionsSuccess = loadedPermissions => { return crudActions.loadSuccess(loadedPermissions); };
export const loadPermissionsFail = error => { return crudActions.loadFail(error); };
export const loadPermission = id => {
    return async dispatch => {

        await crudActions.load(dispatch, id);
    };
};

export const uploadPermissionStart = () => {
    return {
        type: 'UPLOAD_PERMISSION_START',
    };
};
export const uploadPermissionSuccess = () => {
    return {
        type: 'UPLOAD_PERMISSION_SUCCESS',
    };
};
export const uploadPermissionFail = () => {
    return {
        type: 'UPLOAD_PERMISSION_FAIL',
    };
};

export const uploadProgress = (data) => {
    return {
        type: 'PERMISSION|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart
    };
};



export const uploadPermissions = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }))
                }
            }
            dispatch(uploadPermissionStart())
            let res = await rest.post('permissions/import', data, config);
            if (res.data.status === 200) {
                dispatch(uploadPermissionSuccess())
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                dispatch(uploadProgress({ progress: 100, loadSize: 0, maxSize: 0, snackStart: false }))

                return res.data.status === 200;
            }
            else {
                dispatch(uploadPermissionFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

                return false;

            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))
            dispatch(uploadPermissionFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}
